import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'ui-video-preview',
  templateUrl: './video-preview.component.html',
  styleUrls: ['./video-preview.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VideoPreviewComponent {
  @Input() public imageUrl = '';
  @Output() public playClicked = new EventEmitter<void>();

  public onPlay(e: MouseEvent | KeyboardEvent): void {
    if (e instanceof KeyboardEvent && e.key !== 'Enter') return;
    e.stopPropagation();

    this.playClicked.emit();
  }
}
